import React, { useEffect, useState } from "react";
import Layout from "../../components/layout/layout";
import { fetchPublishedArticles } from "../../lib/articles";
import ArticleGrid from "../../components/articles/article-grid";
import HeroTemplateCandidats from "../../components/sections/HeroTemplateCandidats";
import Breadcrumb from "../../components/ui/breadcrumb";
import { WebPageSchema, BreadcrumbSchema } from "../../lib/utils/schema-utils";

export default function ArticlesPage() {
  const [articles, setArticles] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [isLoading, setIsLoading] = useState(true);

  const categories = [
    { id: "all", name: "Toutes les catégories" },
    { id: "Recrutement", name: "Recrutement" },
    { id: "Marque employeur", name: "Marque employeur" },
    { id: "RH & Management", name: "RH & Management" },
    { id: "Onboarding", name: "Onboarding" },
    { id: "Culture d'entreprise", name: "Culture d'entreprise" },
    { id: "Innovation RH", name: "Innovation RH" },
    { id: "Général", name: "Général" },
  ];

  useEffect(() => {
    const loadArticles = async () => {
      setIsLoading(true);
      const data = await fetchPublishedArticles();
      setArticles(data);
      setIsLoading(false);
    };

    loadArticles();
  }, []);

  const filteredArticles =
    selectedCategory === "all"
      ? articles
      : articles.filter((article) => article.category === selectedCategory);

  return (
    <>
      <WebPageSchema
        page={{
          title: "Articles RH, Recrutement & Management",
          description:
            "Des contenus concrets et inspirants. Recrutement, onboarding, marque employeur et plus. Méthodes, outils, pratiques : on partage ce qui marque sur le terrain pour booster vos pratiques RH.",
          url: "https://recruteurs.io/ressources/articles",
          lastReviewed: "2025-05-22",
        }}
      />

      <BreadcrumbSchema
        items={[
          { name: "Ressources", url: "/ressources" },
          { name: "Articles", url: "/ressources/articles" },
        ]}
      />

      <Layout>
        <>
          <HeroTemplateCandidats
            page="articles"
            section="hero"
            title={
              <>
                <span className="text-[42px] text-[initial] align-middle mr-2">📚</span>
                <span className="text-black">Articles RH, Recrutement</span>
                <br />
                <span className="text-gradient">& Management</span>
              </>
            }
            description={
              <p className="text-neutral-800">
                Des contenus concrets et inspirants. Recrutement, onboarding, marque employeur et plus encore.
                <br />
                Méthodes, outils, bonnes pratiques : on partage ce qui marque sur le terrain pour booster vos pratiques RH, recruter mieux, intégrer plus vite, et engager durablement vos équipes.
              </p>
            }
            imageUrl="https://ygkvhunsrhvgddngoulm.supabase.co/storage/v1/object/public/backgrounds/backgrounds/articles-recrutement-innovant.webp"
            cta1={{
              label: "Toutes les catégories",
              onClick: () => setSelectedCategory("all"),
            }}
            cta2={{
              label: "S'abonner à la newsletter",
              href: "#newsletter",
            }}
            breadcrumbs={[
              { name: "Ressources", href: "/ressources" },
              { name: "Articles", href: "/ressources/articles" },
            ]}
            customRight={
              <div
                className="hs-form-frame w-full"
                data-region="na1"
                data-form-id="9751b2d3-cee0-494f-b191-287b8bf3e2ab"
                data-portal-id="4621272"
              ></div>
            }
          />

          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
            <div className="flex items-center justify-between mb-8">
              <h2 className="text-3xl font-bold">Nos derniers articles</h2>
              <div className="flex gap-4 overflow-x-auto">
                {categories.map((cat) => (
                  <button
                    key={cat.id}
                    className={`text-sm px-4 py-2 rounded-full border ${
                      selectedCategory === cat.id
                        ? "bg-primary text-white border-primary"
                        : "bg-white text-neutral-700 border-neutral-200"
                    }`}
                    onClick={() => setSelectedCategory(cat.id)}
                  >
                    {cat.name}
                  </button>
                ))}
              </div>
            </div>

            {isLoading ? (
              <p>Chargement des articles...</p>
            ) : (
              <ArticleGrid articles={filteredArticles} />
            )}
          </div>
        </>
      </Layout>
    </>
  );
}